import React from "react";

import Style from "./Style";

export default function index() {
  return <Style>Document</Style>;
}
